import React from 'react';

interface IUploadFileIconProps {
	size?: string;
	fill?: string;
}

export const UploadFileIcon = ({ size = '48', fill }: IUploadFileIconProps) => (
	<svg aria-hidden="true" width={size} height={size} viewBox="0 0 49 48" fill="none">
		<path
			d="M23 34.5C23 37.6826 24.2643 40.7348 26.5147 42.9853C28.7652 45.2357 31.8174 46.5 35 46.5C38.1826 46.5 41.2348 45.2357 43.4853 42.9853C45.7357 40.7348 47 37.6826 47 34.5C47 31.3174 45.7357 28.2652 43.4853 26.0147C41.2348 23.7643 38.1826 22.5 35 22.5C31.8174 22.5 28.7652 23.7643 26.5147 26.0147C24.2643 28.2652 23 31.3174 23 34.5Z"
			stroke={fill || '#707070'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M35 40.5V28.5"
			stroke={fill || '#707070'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M35 28.5L30.5 33"
			stroke={fill || '#707070'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M35 28.5L39.5 33"
			stroke={fill || '#707070'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M17 40.5H5C4.20435 40.5 3.44129 40.1839 2.87868 39.6213C2.31607 39.0587 2 38.2956 2 37.5V4.5C2 3.70435 2.31607 2.94129 2.87868 2.37868C3.44129 1.81607 4.20435 1.5 5 1.5H26.258C27.0531 1.50017 27.8156 1.81596 28.378 2.378L34.122 8.122C34.684 8.6844 34.9998 9.44691 35 10.242V16.5"
			stroke={fill || '#707070'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
